module.exports = __webpack_public_path__ + "img/school.2f0881ce.svg";